import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Button } from 'antd'
import TodayTag from '../../../components/UI/todayTag'
import DataTable from '../../../components/UI/table'
import PageLoading from '../../../components/UI/status/loading'
import {
  getCircuitTrainingSessions,
  exportSessions
} from '../../../api/eventRegistration'
import moment from 'moment'
import _ from 'lodash'

export const Container = styled.div`
  .page-header {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    padding-bottom: 24px;
    .title {
      font-weight: 500;
      font-size: 36px;
      letter-spacing: 0.3px;
      color: #323f4a;
    }
    .action {
      display: flex;
      align-items: center;
      button {
        height: 39px;
        width: 131px;
      }
    }
  }
  .page-content {
    padding: 24px 0;
    .description {
      letter-spacing: 0.3px;
      font-size: 18px;
      font-weight: 700;
      color: #383e48;
      p:first-child {
        margin-bottom: 4px;
      }
      .time {
        font-size: 14px;
        font-weight: 500;
        color: #5e687d;
      }
    }
    .ant-table-thead > tr > th {
      font-size: 12px;
      color: #5c626a;
      background: white;
      letter-spacing: 0.3px;
    }
    .ant-table-tbody > tr > td {
      font-size: 14px;
      color: #5e687d;
      vertical-align: top;
      letter-spacing: 0.3px;
      font-weight: 400;
    }
  }
`

const booleanRender = (value) => {
  return (
    <div
      style={{
        textAlign: 'center'
      }}
    >
      {value ? 'Yes' : 'No'}
    </div>
  )
}

const columns = [
  {
    title: 'TIME',
    dataIndex: 'created_at',
    key: 'created_at',
    width: 160,
    render: (value) => {
      return moment(value).format('M/D/YY - h:mm A')
    },
    sorter: (left, right) => {
      return moment(left.created_at).unix() - moment(right.created_at).unix()
    }
  },
  {
    title: 'NAME',
    dataIndex: 'name',
    key: 'name',
    width: 155,
    sorter: (a, b) => {
      return (
        a.name.toLowerCase().charCodeAt() - b.name.toLowerCase().charCodeAt()
      )
    }
  },
  {
    title: 'EMAIL ADDRESS',
    dataIndex: 'email',
    key: 'email',
    width: 180,
    sorter: (a, b) => {
      return (
        a.email.toLowerCase().charCodeAt() - b.email.toLowerCase().charCodeAt()
      )
    }
  },
  {
    title: 'ATTEND?',
    dataIndex: 'attend',
    key: 'attend',
    render: booleanRender
  },
  {
    title: 'BRING GUESTS?*',
    dataIndex: 'bring_guest',
    key: 'bring_guest',
    width: 133,
    render: booleanRender
  },
  {
    title: 'GUEST NAME',
    dataIndex: 'guest',
    key: 'guest',
    width: 150,
    render: (value, record) => {
      const guests = [1, 2, 3, 4]
        .map((e) => _.get(record, `guest_${e}`))
        .filter((e) => e)
      if (guests.length > 0) {
        return guests.map((e) => (
          <>
            {e}
            <br />
          </>
        ))
      } else {
        return '--'
      }
    }
  },
  {
    title: 'NOTE',
    dataIndex: 'supplement',
    key: 'note',
    render: (value) => {
      const result = _.trim(value)
      return <div style={{ whiteSpace: 'pre-line' }}>{result || '--'}</div>
    }
  }
]

export default function EventRegistration() {
  const [loading, setLoading] = useState(true)
  const [dataSource, setDataSource] = useState([])
  const [exporting, setExporting] = useState(false)

  const exportData = async () => {
    setExporting(true)
    const report = await exportSessions()
    window.open(report.url)
    setExporting(false)
  }

  useEffect(() => {
    initial()
  }, [])

  return loading ? (
    <PageLoading />
  ) : (
    <Container>
      <div className="page-header">
        <div className="title">Event Registration</div>
        <div className="action">
          {/* <DateRange /> */}
          <TodayTag />
          <Button
            type="primary"
            loading={exporting}
            disabled={exporting}
            onClick={exportData}
          >
            EXPORT
          </Button>
        </div>
      </div>
      <div className="page-content">
        <div className="description">
          <p>September Group Ride</p>
          <p className="time">
            Sunday, September 24, 9:00am,{' '}
            <a
              href="https://www.google.com/maps/place/CA-92+%26+Cañada+Rd,+California+94402/@37.4894239,-122.3228583,13.91z/data=!4m6!3m5!1s0x808f9fe90476acb7:0xe58962b883bc98be!8m2!3d37.5071036!4d-122.341274!16s%2Fg%2F11f39d19rl?entry=ttu"
              target="_blank"
              rel="noopener noreferrer"
            >
              Cañada Rd and 92
            </a>
            .
          </p>
        </div>
        <DataTable
          dataSource={dataSource}
          columns={columns}
          hidePagination={true}
        />
      </div>
    </Container>
  )

  async function initial() {
    const { list } = await getCircuitTrainingSessions()
    setDataSource(list)
    setLoading(false)
  }
}
